import { IconFn, IconSvg } from "../createIcon";

export const DeleteIcon: IconFn = ({ color = "#655C94", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 20, height: 20 }} {...props}>
    <path
      d="M7.805 3.415h3.902a1.951 1.951 0 0 0-3.902 0Zm-1.464 0a3.414 3.414 0 1 1 6.83 0h5.61a.732.732 0 0 1 0 1.463h-1.288L16.35 16.694A3.658 3.658 0 0 1 12.708 20H6.804a3.658 3.658 0 0 1-3.642-3.306L2.02 4.878H.732a.732.732 0 0 1 0-1.463h5.61Zm1.952 4.634a.732.732 0 1 0-1.464 0v7.317a.732.732 0 0 0 1.464 0V8.049Zm3.658-.732a.732.732 0 0 1 .732.732v7.317a.732.732 0 0 1-1.463 0V8.049a.732.732 0 0 1 .731-.732ZM4.62 16.553a2.195 2.195 0 0 0 2.185 1.984h5.904a2.195 2.195 0 0 0 2.186-1.984l1.13-11.675H3.488l1.13 11.675Z"
      fill={color}
    />
  </IconSvg>
);
